import { useEffect, useRef } from 'react';
import { autorun, reaction } from 'mobx';
import { useStore } from '@vromo/mobx-react';
import { RootStore } from './stores/RootStore';

export default function Notifications(): null {
    const rootStore = useStore<RootStore>('rootStore');

    const lastOpened = useRef({
        chat: Date.now(),
        issues: Date.now()
    });
    const jobsLength = useRef<number>();
    const visibilityState = useRef(document.visibilityState);

    useEffect(() => {
        if (!('Notification' in window)) {
            return;
        }

        if (Notification.permission === 'default') {
            Notification.requestPermission();
        }

        function listener(e: any) {
            visibilityState.current = e.target.visibilityState;
        }

        document.addEventListener('visibilitychange', listener);
        return () => document.removeEventListener('visibilitychange', listener);
    }, []);

    useEffect(() => {
        if (!('Notification' in window)) {
            return;
        }

        const callbacks: Array<() => void> = [];

        callbacks.push(
            autorun(() => {
                const jobIssues = rootStore.jobStore.jobs.filter(
                    (it) => it.issues && it.issues.length
                );

                jobIssues.forEach((job) => {
                    const newIssues = job.issues.filter(
                        (issue) => issue.created > lastOpened.current.issues
                    );

                    newIssues.forEach((issue) => {
                        if (visibilityState.current === 'hidden') {
                            new Notification(issue.description, {
                                body: job.name,
                                icon: require('./router/favicon.png')
                            });
                        }
                    });
                });

                lastOpened.current.issues = Date.now();
            })
        );

        callbacks.push(
            autorun(() => {
                const jobChats = rootStore.jobStore.jobs.filter((it) => it.chat && it.chat.length);

                jobChats.forEach((job) => {
                    const newChats = job.chat.filter(
                        (chat) => chat.created > lastOpened.current.chat
                    );

                    newChats.forEach((chat) => {
                        if (visibilityState.current === 'hidden') {
                            new Notification('New message', {
                                body: chat.message || '',
                                icon: require('./router/favicon.png')
                            });
                        }
                    });
                });

                lastOpened.current.chat = Date.now();
            })
        );

        callbacks.push(
            reaction(
                () => rootStore.jobStore.jobs.length,
                (numberOfJobs) => {
                    const newJob = rootStore.jobStore.jobs.last();
                    if (numberOfJobs !== undefined && numberOfJobs > jobsLength.current) {
                        new Notification('New order created', {
                            body: newJob.name,
                            icon: require('./router/favicon.png'),
                            requireInteraction: true
                        });
                    }
                    jobsLength.current = numberOfJobs;
                }
            )
        );

        return () => callbacks.forEach((it) => it());
    });

    return null;
}
